import common from "@well-b/well-b-shared";
import moment from "moment";

export const dateRangeFieldConfig = (optional = false) => ({
    startDate: {
        name: "startDate",
        type: "date",
        label: "תאריך התחלה",
        optional,
        transform: date => moment(date).startOf("days").valueOf()
    },
    endDate: {
        name: "endDate",
        type: "date",
        label: "תאריך סיום",
        optional,
        transform: date => moment(date).endOf("days").valueOf()
    }
});

const dateRangeByCreatedAtFieldsConfig = (optional = false) => ({
    ...dateRangeFieldConfig(optional),
    byCreatedAt: {
        name: "byCreatedAt",
        type: "boolean",
        label: "סינון לפי תאריך הזמנה",
        unCheckedChildren: "תאריך הזמנה",
        checkedChildren: "תאריך אספקה",
        optional,
        transform: value => !value
    }
});

export const reports = [
    {
        key: common.report.ReportName.ADMIN_ORDER_EXCEL_CSM_SUPPLIES,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_ORDER_EXCEL_CSM_SUPPLIES],
        fields: dateRangeByCreatedAtFieldsConfig()
    },
    {
        key: common.report.ReportName.ADMIN_WELL_B_SHIPPING_SUPPLY_REPORT,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_WELL_B_SHIPPING_SUPPLY_REPORT],
        fields: dateRangeByCreatedAtFieldsConfig()
    },
    {
        key: common.report.ReportName.ADMIN_ORDER_EXCEL_PROVIDER_SUPPLIES,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_ORDER_EXCEL_PROVIDER_SUPPLIES],
        fields: dateRangeByCreatedAtFieldsConfig()
    },
    {
        key: common.report.ReportName.TOTAL_SUB_ADMINS_COMPANY_BUDGET_USAGE,
        value: common.report.ReportsNameToText[common.report.ReportName.TOTAL_SUB_ADMINS_COMPANY_BUDGET_USAGE],
        fields: {
            ...dateRangeFieldConfig(),
            companyId: {
                name: "companyId",
                label: "מזהה חברה"
            }
        }
    },
    {
        key: common.report.ReportName.ADMIN_ORDER_EXCEL_ERP_REPORT,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_ORDER_EXCEL_ERP_REPORT],
        fields: dateRangeByCreatedAtFieldsConfig()
    },
    {
        key: common.report.ReportName.ADMIN_PROVIDERS_EXCEL,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_PROVIDERS_EXCEL]
    },
    {
        key: common.report.ReportName.COMPANIES_REPORT,
        value: common.report.ReportsNameToText[common.report.ReportName.COMPANIES_REPORT],
        fields: {
            ...dateRangeFieldConfig(true),
            systemId: {
                label: "מערכת",
                name: "systemIds",
                multiple: "multiple",
                type: "select",
                options: Object.entries(common.themeNames).map(([key, value]) => ({
                    name: key?.toLowerCase(),
                    label: value?.toLowerCase() ?? key?.toLowerCase()
                }))
            }
        }
    },
    {
        key: common.report.ReportName.ADMIN_TRANSACTION_REPORT,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_TRANSACTION_REPORT],
        fields: dateRangeByCreatedAtFieldsConfig()
    },
    {
        key: common.report.ReportName.ADMIN_USER_REPORT,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_USER_REPORT],
        fields: dateRangeByCreatedAtFieldsConfig()
    },
    {
        key: common.report.ReportName.ADMIN_OUTSTANDING_DEBTS_REPORT,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_OUTSTANDING_DEBTS_REPORT],
        fields: dateRangeFieldConfig()
    },
    {
        key: common.report.ReportName.ADMIN_TRANSACTIONS_ISSUES_REPORT,
        value: common.report.ReportsNameToText[common.report.ReportName.ADMIN_TRANSACTIONS_ISSUES_REPORT],
        fields: dateRangeByCreatedAtFieldsConfig()
    }
];
